module.exports = __webpack_public_path__ + "img/DE00501.52f06281.png";